module.exports = __webpack_public_path__ + "img/finger.c7cd7e17.png";